// src/components/battle/BattleCard.jsx
import { useNavigate } from "react-router-dom";
import { MapPin } from "lucide-react";


const MODE_LABEL = {
  0: "개인전",
  1: "팀전",
};

const STATUS_LABEL = {
  0: "모집중",
  1: "모집완료",
  2: "종료",
};

const GENDER_LABEL = {
  0: "남자전",
  1: "여자전",
  2: "혼성전",
};

const ACCENT = "rgb(0, 224, 198)";

function formatDateTime(iso) {
  if (!iso) return "-";
  const [date, time] = iso.split("T");
  const [hh, mm] = time.split(":");
  return `${date.replace(/-/g, ".")} ${hh}:${mm}`;
}

export default function BattleCard({ battle, onSelect }) {
  const navigate = useNavigate();

  const {
    battleId,
    courseName,
    battleName,
    battleStartDate,
    status,
    mode,
    genderType,
    courseImage,

    // ⬇️ 있으면 쓰고, 없으면 안전하게 fallback
    startLocationName,
    startLocation,
    distance,
    avgRating,
    ratingAvg,
    type,
  } = battle;

  const statusCode = Number(status);
  const modeCode = Number(mode);
  const genderCode =
    genderType !== undefined && genderType !== null ? Number(genderType) : null;

  const statusLabel = STATUS_LABEL[statusCode] ?? "상태미정";
  const modeLabel = MODE_LABEL[modeCode] ?? "모드미정";
  const genderLabel =
    genderCode === null ? "전체" : GENDER_LABEL[genderCode] ?? "전체";

  const isClosed = statusCode !== 0;
  const dateText = battleStartDate || formatDateTime(battle.startDatetime);

  const locationText =
    startLocationName || startLocation || courseName || "출발 위치 정보 없음";

  const rating =
    ratingAvg != null
      ? Number(ratingAvg)
      : avgRating != null
      ? Number(avgRating)
      : null;

  const handleClick = () => {
    if (onSelect) onSelect(battleId);
    else navigate(`/battle/getBattle?battleId=${battleId}`);
  };

  return (
    <article
      onClick={handleClick}
      className="
        w-full overflow-hidden rounded-2xl bg-white shadow-md
        active:scale-[0.99] transition-transform cursor-pointer
      "
    >
      {/* ✅ 상단 썸네일(지도/그라데이션) */}
      <div className="relative h-32 w-full">
        {courseImage ? (
          <img
          
            src={courseImage}
            alt={courseName || battleName}
            className="h-full w-full object-cover"
            loading="lazy"
          />
        ) : (
          <div
            className="
              h-full w-full
              bg-gradient-to-br from-emerald-200 via-cyan-200 to-sky-300
              flex items-center justify-center
            "
          >
            <MapPin className="w-10 h-10 text-white/80" strokeWidth={2} />
          </div>
        )}

     


      </div>

      {/* ✅ 하단 정보 */}
      <div className="p-4">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <h3 className="text-[15px] font-semibold text-slate-900 truncate">
              {battleName}
            </h3>

            <div className="mt-1 flex items-center gap-1 text-[12px] text-slate-500">
              <MapPin className="w-4 h-4" />
              <span className="truncate">{locationText}</span>
            </div>
          </div>

          {/* 우측 작은 상태칩(민트 라인형) */}
          <span
            className="shrink-0 text-[11px] px-2.5 py-1 rounded-full font-semibold"
            style={{
              border: `1px solid ${ACCENT}`,
              backgroundColor: "rgba(0,224,198,0.10)",
              color: ACCENT,
            }}
          >
            {statusLabel}
          </span>
        </div>

        {/* 날짜/모드 */}
        <div className="mt-2 text-[12px] text-slate-500">
          {dateText} · {modeLabel}
          {battle.teamSize ? ` · 팀당 ${battle.teamSize}명` : null}
        </div>

        {/* ✅ 하단 칩들 */}
        <div className="mt-3 flex flex-wrap gap-2">
          {/* 거리(있을 때만) */}
          {distance != null && (
            <span
              className="text-[11px] px-3 py-1 rounded-full"
              style={{
                backgroundColor: "rgba(0,224,198,0.10)",
                color: ACCENT,
                border: `1px solid rgba(0,224,198,0.25)`,
              }}
            >
              {Number(distance)}km
            </span>
          )}

          {/* 코스명 */}
          {courseName && (
            <span className="text-[11px] px-3 py-1 rounded-full bg-slate-100 text-slate-600">
              {courseName}
            </span>
          )}

          {/* 성별 */}
          <span className="text-[11px] px-3 py-1 rounded-full bg-slate-100 text-slate-600">
            {genderLabel}
          </span>

          {/* 타입(러닝/산책 등 있으면) */}
          {type && (
            <span className="text-[11px] px-3 py-1 rounded-full bg-slate-100 text-slate-600">
              {type}
            </span>
          )}
        </div>
      </div>
    </article>
  );
}
